import React, { useEffect, useState } from 'react';
import { GithubPicker } from 'react-color';
import PropTypes from 'prop-types';

const ColorPicked = (props) => {
  const { onHandleChange, colorSelected } = props;
  const [backgroundColor, setBackgroundColor] = useState('#FFCDD2');
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleChange = (color) => {
    const { hex } = color;
    onHandleChange(hex);
    setBackgroundColor(hex);
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  useEffect(() => {
    if (colorSelected) {
      setBackgroundColor(colorSelected);
    }
  }, [colorSelected]);

  return (
    <div>
      <button
        name="color"
        type="button"
        style={{ background: backgroundColor }}
        className="color-picked"
        onClick={handleClick}
      />
      {displayColorPicker ? (
        <div className="color-picked-popover">
          <GithubPicker
            colors={[
              '#FFCDD2',
              '#F8BBD0',
              '#E1BEE7',
              '#B39DDB',
              '#C5CAE9',
              '#BBDEFB',
              '#FFF9C4',
              '#B3E5FC',
              '#B2EBF2',
              '#B2DFDB',
              '#84FFFF',
              '#A7FFEB',
              '#C8E6C9',
              '#FFECB3',
              '#FFCCBC',
              '#D7CCC8',
            ]}
            width="215px"
            onChange={handleChange}
            style={{ card: { border: '2px solid black' } }}
          />
        </div>
      ) : null}
    </div>
  );
};

ColorPicked.propTypes = {
  onHandleChange: PropTypes.func.isRequired,
  colorSelected: PropTypes.string,
};

ColorPicked.defaultProps = {
  colorSelected: null,
};

export default ColorPicked;
